module.exports = __webpack_public_path__ + "static/media/PromoImage_Loyalty.e6063caa.png";